import PropTypes from "prop-types"
import styled from "styled-components"

const NavBarContainer = styled.div`
  display: flex;
  ${({ theme }) => theme.se`
    padding: 10px 20px;
    justify-content: space-between;
    width: 100%;
  `} 

  ${({ theme }) => theme.tablet`
   
  `}

  ${({ theme }) => theme.desktop`
    padding: 25px 20px;
    max-width: 1200px;
    margin: auto;
  `}

  ${({ theme }) => theme.largeDesktop`
    max-width: 1400px;
  `}
`

NavBarContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default NavBarContainer
